import { useMemo, useCallback } from "react";
import { assertUnreachable } from "@aidkitorg/types/lib/typechecks";
import { Button } from "@aidkitorg/component-library";
import { useLocalizedStrings } from "../../../Localization";
import { useConnectionModal } from "./ConnectionModalContext";
import { SourceHeader } from "./SourceHeader";
import { type ConnectionModalState } from "./types";
import { useMarkdown } from "../../../Util";

interface ConnectionModalErrorPageProps {
  state: ConnectionModalState & { stage: "error" };
}

export function ConnectionModalErrorPage({
  state,
}: ConnectionModalErrorPageProps) {
  const L = useLocalizedStrings();
  const { getLocalizedString, setAccessToken, onUpdateState, onExit } = useConnectionModal();

  const additionalText = useMarkdown(getLocalizedString("additionalErrorMessageText"));
  const returnToSourcePageText = useMarkdown(getLocalizedString("returnToSourcePageText", "return_to_source_page"), undefined, true);

  const handleClickBackToSource = useCallback(() => {
    setAccessToken(null);
    onUpdateState({
      stage: "source",
      selectedSource: state.selectedSource,
    });
  }, [onUpdateState, state]);

  return <div>
    <SourceHeader source={state.selectedSource} />
    <div className="mt-2">{state.errorMessage}</div>
    <div>{additionalText}</div>
    <div className="flex mt-2">
      <Button onClick={handleClickBackToSource} variant="primary">
        {returnToSourcePageText}
      </Button>
      <Button className="ml-auto" onClick={onExit} variant="secondary">
        {L.component_library.modal.close}
      </Button>
    </div>
  </div>
}
